// extracted by mini-css-extract-plugin
export var modalFooter = "_pd-0";